import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import { Card } from "react-bootstrap";
import NumberFormat from "react-number-format";

//
import Point from "../../../assets/img/point.png";
import ChargePointsModal from "./ChargePointsModal";

function Points({ user }) {
  const userPoints = () => {
    let balance = 0;
    let wallets = user.wallets;

    //
    for (let i = 0; i < wallets.length; i++) {
      const wallet = wallets[i];
      if (wallet.type === "point") {
        balance = wallet.balance;
      }
    }

    return balance;
  };

  return (
    <Card className="points bordered">
      <Card.Body>
        <img src={Point} alt="plan" />
        <div>
          <p>
            Points you have {" "}
            <ChargePointsModal />
          </p>
          <h5 className="fw-bolder">
            <NumberFormat
              value={userPoints()}
              displayType={"text"}
              thousandSeparator={true}
              decimalSeparator="."
              className="me-1"
            />
            Points
          </h5>
        </div>
      </Card.Body>
    </Card>
  );
}

Points.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
});

export default connect(mapStateToProps)(Points);
